import cn from 'classnames';
import { FreeTierBanner } from 'src/components/ProductDetailed/FreeTierBanner';
import { WarpAuthorType } from 'src/types';

import s from './Info.module.scss';

export function Info({
  title,
  categoryTitle,
  articleCreatedAt,
  articleTimeToRead,
  description,
  authors,
}: {
  title: string;
  categoryTitle: string;
  articleCreatedAt: string;
  articleTimeToRead?: string;
  description: string;
  authors: WarpAuthorType[];
}) {
  const timeToRead = 'Время чтения';

  return (
    <div className={s.root}>
      <h1 className={s.title} data-qa="page-title">
        {title}
      </h1>

      <FreeTierBanner variant="small" className={s.banner} withoutWrapper />

      <div className={s.content}>
        {authors?.length > 0 && (
          <div className={cn(s.item, s.author)} data-qa="article-author">
            <img
              alt="Avatar icon"
              src={authors[0].avatar ?? '/svg/pages/warp/webinar/no-avatar.svg'}
              className={s.avatar}
              data-qa="article-author-avatar"
              width={64}
              height={64}
            />
            <div className={s.authorContent}>
              <p
                className={cn(s.subtitle, s.subtitleAuthor)}
                data-qa="article-author-name"
              >
                {`${authors[0].name} ${authors[0].secondName}`}
              </p>
              <p className={s.text} data-qa="article-author-position">
                {authors[0].position}
              </p>
            </div>
          </div>
        )}
        <div className={s.item}>
          <p className={s.subtitle} data-qa="article-category">
            {categoryTitle}
          </p>
          <time className={s.text} data-qa="article-date">
            {articleCreatedAt}
          </time>
        </div>
        {articleTimeToRead && (
          <div className={s.item}>
            <p className={s.subtitle} data-qa="article-time-to-read-title">
              {timeToRead}
            </p>
            <p className={s.text} data-qa="article-time-to-read">
              {articleTimeToRead}
            </p>
          </div>
        )}
      </div>
      <div
        className={s.desc}
        data-qa="page-description"
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </div>
  );
}
